module.exports = __webpack_public_path__ + "media/images/icons/icon_calendar_full-c447a6623631883ad79095d4c146652e.svg";